import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function GameSessionDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"Campaign Details"}
                            endpoint={"campaign/read"}
                            relations={["tenant", "currency", "jackpots"]} 
                            manyToManyRelations={[{
                                name: "tenant",
                                title: "Tenants",
                                columnTitles: ["Tenant", "External ID"],
                                objectKeys: ["name", "external_id"],
                            }]}
                            oneToManyRelations={[
                                {
                                    title: "Jackpots",
                                    columnTitles: [
                                        "ID", "Name", "Provider Jackpot ID", "Type", "Contribution Percentage", "Value"
                                    ],
                                    name: "jackpots",
                                    objectKeys: ["id", "name", "provider_jackpot_id", "type", "contribution_percentage", "value"],
                                    
                                }
                            ]}
                        
                        />
}

export default GameSessionDetailsPage;